const geocodeByAddress = (
  address: string,
): Promise<google.maps.GeocoderResult[]> => {
  if (!window.google?.maps?.Geocoder) {
    return Promise.reject(new Error('Google map api is not available.'));
  }

  const geocoder = new window.google.maps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        resolve(results || []);

        return;
      }
      if (status === window.google.maps.GeocoderStatus.ZERO_RESULTS) {
        resolve([]);

        return;
      }
      reject(new Error(status));
    });
  });
};

export default geocodeByAddress;
